export default {
  abandonProduct: 'Abandonar produto',
  abandonProductTips:
    'Lembrete amigável: Após confirmar [Abandonar produto], destruiremos seu produto e não poderá ser restaurado. O produto não será devolvido ao vendedor para reembolso. Por favor, opere com cuidado.',
  finePhotos: 'Fotos finas',
  ordinaryPhotos: 'Fotos comuns',
  expireText: 'Pacote prestes a expirar',
  more: 'Mais',
  timeExpand: 'Estender tempo',
  guaranteeService: 'Serviço de garantia',
  noNeed: 'Não precisa',
  'i18n-0000002':
    'Seus produtos estão vencidos, vamos guardá-los temporariamente por 28 dias. Após esse período, os produtos serão considerados abandonados e tratados adequadamente.',
  'i18n-0000003':
    'Se você precisar estender o período de armazenamento, por favor compre o serviço de valor agregado de extensão de armazenamento dentro de 28 dias.',
  'i18n-0000004': 'Tempo de expiração do armazenamento',
  'i18n-0000016': 'Armazenamento de produtos expirado',
  'i18n-0000019': 'Usuário não renovou serviço de armazenamento, padrão abandonar produto',
  'i18n-0000023': 'Concluído',
  refundTip: 'Após confirmação, a taxa de armazenamento será reembolsada à sua conta.',
  storageEnum: {
    1: 'Armazém China 1',
    2: 'Armazém China 2',
  },
  'i18n-00001':
    'Concordo que o acbuy modifique as informações de declaração para atender aos requisitos alfandegários locais, melhorar a taxa de liberação alfandegária. Se não comprou seguro, assumo a responsabilidade e consequências da liberação alfandegária resultante',
  'i18n-00002':
    'Não concordo com a modificação, por favor declare de acordo com as informações originais, assumo a responsabilidade e consequências da liberação alfandegária resultante',
  'i18n-00003': 'Concordo com a modificação',
  'i18n-00004': 'Não concordo com a modificação',
  'i18n-00005': 'Modificação de informações de declaração',
  'i18n-00006':
    'Cada informação de declaração precisa ter mais de 25 caracteres, por favor ajuste e envie novamente',
  'i18n-00007':
    'O peso é estimado com base no maior valor entre peso real e peso volumétrico. Qualquer diferença será reembolsada ou complementada dentro de 72 horas após a pesagem.',
  'i18n-00008':
    'Cada informação de declaração precisa ter menos de {length} caracteres, por favor ajuste e envie novamente',
  'i18n-00009':
    '{AI} ainda tem serviços de valor agregado não pagos. Se precisar manter, por favor complete o pagamento primeiro e aguarde a conclusão do serviço antes de enviar o pacote; Se confirmar o envio do pacote, o sistema cancelará automaticamente os serviços de valor agregado não pagos.',
}
